var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgChevron(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 48 256 160"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "inherit",
    d: "M128 48.907l-128 128 30.187 30.186L128 109.28l97.813 97.813L256 176.907z"
  })));
}
export default SvgChevron;